import { render, staticRenderFns } from "./MetricDepartures.vue?vue&type=template&id=73edb07b&"
import script from "./MetricDepartures.vue?vue&type=script&lang=js&"
export * from "./MetricDepartures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports